import { useQuery } from '@tanstack/react-query';
import { User } from 'src/admin/users/types';

export function useOneAdvisor(id?: string, skip = false) {
  const { data, isLoading, isError, error } = useQuery<User>({
    queryKey: ['users', id],
    enabled: !!id && !skip,
  });

  return { advisor: data ?? null, isLoading, isError, error };
}
